<div>
  <nav class="navbar navbar-expand-lg bg-primary shadow">
    <div class="container-fluid">
      <!-- Menu izquierda -->
      <div class="nav col-md-2 d-flex align-items-center">
        <a [routerLink]="['/Acceso']" data-bs-target="#sidebar" data-bs-toggle="collapse"
          class="text-white text-decoration-none p-2 w-25">
          <i class="fa-solid fa-house"></i>
        </a>
      </div>

      <!-- Menu centro -->
      <div class="nav justify-content-center col-md-4 text-center">
        <div class="d-flex flex-column">
          <h6 class="fw-bold text-white">{{ (user$ | async)?.vcPrimerNombre }} {{ (user$ | async)?.vcPrimerApellido }}</h6>
          <h5 class="text-secondary fw-bold">SOLICITUD DE SERVICIO</h5>
        </div>
      </div>

      <div class="nav col-md-4 d-flex flex-row justify-content-end">
        <form class="d-flex p-md-1 align-items-start">
          <a class="d-none d-md-block">
            <img src="./assets/images/LOGOS_PNG/LOGO ESCUDO SDS.png" height="95" alt="" loading="lazy">
          </a>
        </form>
      </div>

      <div ngbDropdown class="nav-item col-md-2 d-flex flex-row justify-content-end">
        <button class="btn dropdown-toggle" id="dropdownBasic1" ngbDropdownToggle>
          <div class="cursor-pointer symbol symbol-30px symbol-md-40px">
            <img [src]="gravatarUrl" alt="Gravatar" style="width: 1.8rem;"/>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem class="dropdown-item btn btn-light">{{ (user$ | async)?.vcPrimerNombre }} {{ (user$ |
            async)?.vcPrimerApellido }}</button>
          <button ngbDropdownItem class="dropdown-item btn btn-light">{{ (user$ | async)?.vcCorreo }}</button>
          <button ngbDropdownItem type="button" class="dropdown-item btn btn-secondary" (click)="logout()">Cerrar
            Sesion</button>
        </div>
      </div>
    </div>
  </nav>
</div>